<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <h1 class="text-h4 mb-2">Info Pribadi</h1>
        <div class="body-1 text--secondary">
          Kelola informasi profil Anda untuk mengontrol, melindungi dan
          mengamankan akun
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="my-4">
      <v-col cols="12" md="3">
        <v-card outlined>
          <v-card-text>
            <v-btn
              class="d-block mx-auto"
              @click.stop="dialogChangeProfileImage = true"
              icon
              width="144"
              height="144"
            >
              <v-avatar
                :color="user.accountAvatar ? 'white' : 'grey lighten-2'"
                width="144"
                height="144"
              >
                <v-img :src="user.accountAvatar" :alt="user.accountName">
                  <v-card
                    class="mt-auto"
                    color="rgba(0,0,0,0.3)"
                    height="30%"
                    width="100%"
                  >
                    <v-card-text class="py-2">
                      <v-icon color="grey lighten-2">mdi-camera</v-icon>
                    </v-card-text>
                  </v-card>
                </v-img>
              </v-avatar>
            </v-btn>
            <h3 class="body-1 font-weight-bold text-center mt-4 mb-1">
              {{ user.accountName }}
            </h3>
            <p class="ma-0 caption text-center">
              {{ user.accountPosition }}
            </p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-tabs class="custom-tabs" color="light-green">
            <v-tab
              :to="{ name: 'account-profile' }"
              exact
              class="text-capitalize"
            >
              Profil Saya
            </v-tab>
            <!-- <v-tab
              :to="{ name: 'account-setting' }"
              exact
              class="text-capitalize"
            >
              Pengaturan Akun
            </v-tab> -->
            <v-tab
              :to="{ name: 'account-password' }"
              exact
              class="text-capitalize"
            >
              Ganti Password
            </v-tab>
          </v-tabs>
          <router-view />
        </v-card>
      </v-col>
    </v-row>
    <dialog-change-profile
      @cancel="dialogChangeProfileImage = false"
      @save="saveAvatar"
      :show="dialogChangeProfileImage"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import profile from '@/mixins/profile';
import DialogChangeProfile from '@/components/dialog/DialogChangeProfile.vue';
export default {
  mixins: [profile],
  components: {
    DialogChangeProfile
  },
  data() {
    return {
      dialogChangeProfileImage: false
    };
  },
  computed: mapState(['user']),
  methods: {
    async saveAvatar(url) {
      this.clearError();
      await this.updateAvatar(url);
      this.dialogChangeProfileImage = false;
    }
  }
};
</script>
